import * as PdfJs from 'pdfjs-dist';
export default PdfJs;
